import {action} from 'easy-peasy';
import {WEB_RTC_CALL_STATUS} from 'services/WebRTC';

export default {
  status: WEB_RTC_CALL_STATUS.NEW,
  connectedAt: null,

  updateStatus: action((state, status) => {
    state.status = status;
    if (status === WEB_RTC_CALL_STATUS.CONNECTED) {
      state.connectedAt = new Date();
    } else {
      state.connectedAt = null;
    }
  }),
};
